<template>
  <div class="">
    <div class="">
      <table class="table table-striped">
        <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">نام</th>
          <th scope="col">نوع تگ</th>
          <th scope="col">عملیات</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(tag,index) in tags">
          <th scope="row">{{ tag.id }}</th>
          <td>{{ tag.name }}</td>
          <td>

            <span class="badge badge-primary" v-for="item in tag.tag_types">
              {{ tagModelNames[item.model_name] }}
            </span>

          </td>
          <td>

            <div v-if="tableMode =='data'">
              <div class="">
                <router-link :to="{ name: 'TagUpdate',params:{id:tag.id} }" class="ml-3 ">
                  <b-icon class="h5" icon="pencil"/>
                </router-link>

                <b-icon @click="deleteTagWrapper(tag,index)" class="h5" icon="trash"/>
              </div>
            </div>
            <div class="" v-else>
              <b-icon @click="restoreTag(tag,index)" class="h5" icon="arrow-clockwise"/>
            </div>

          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="">
      <pagination :meta="meta" :on-change-page="changePage"/>
    </div>
  </div>
</template>

<script>
import Pagination from "@/plugin/components/dashboard/Pagination.vue";
import {tagModelNames} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Tag";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "TagTable",
  components: {Pagination},
  props: {
    tableMode: {
      default: 'data'
    }
  },
  data() {
    return {
      tagModelNames,
      tags: [],
      meta: [],
    }
  },
  methods: {
    async getTags(page = 1) {
      let form = {
        page: page
      }
      let data;
      if (this.tableMode == 'trash') {
        data = await this.$store.dispatch('Tag/getTagsTrash', form)
      } else {
        data = await this.$store.dispatch('Tag/getTags', form)
      }
      data = data.data.data;
      this.tags = data.data
      this.meta = data.meta
    },
    changePage(page) {
      this.getTags(page)
    },
    deleteTagWrapper(tag, index) {
      if (confirm('آیا از حذف ایتم اطمینان دارید؟')) {
        this.$store.dispatch('Tag/deleteTag', tag).then(res => {
          this.tags.splice(index, 1)
          toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')
        })
      }
    },
    restoreTag(tag, index) {
      if (confirm('آیا از بازیابی ایتم اطمینان دارید؟')) {
        this.$store.dispatch('Tag/restoreTag', tag).then(res => {
          this.tags.splice(index, 1)
          toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')
        })
      }
    },
  },
  mounted() {
    this.getTags()
  }
}
</script>

<style scoped>

</style>